import React from 'react';
import { NotificationViewDto } from 'src/services/user/types';
import { NotificationItem } from './NotificationItem'; 

export const NotificationWidget: React.FC<{ items: NotificationViewDto[], onSetAsRead?: (id: string) => void }>
    = ({ items, onSetAsRead }) => {

        return (


            
            <div className="d-flex flex-wrap">
                {items?.filter(n => n.Visible).map((item) => {
                    return (
                            <NotificationItem key={item.Id} item={item} onSetAsRead={onSetAsRead} />
                    )
                })}
            </div>
        )
    }
